import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFaqData } from '../../hooks/useFaqData';

export const Faq = () => {
  const { t } = useTranslation();
  const { faqCategories } = useFaqData();
  const [openItems, setOpenItems] = useState<Set<string>>(new Set());

  const toggleItem = (itemId: string) => {
    setOpenItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  return (
    <div className="page p-auth page_d1">
      <main className="page__main">
        <div className="page__content">
          <section className="l-section">
            <div className="l-section__line">
              <div className="l-container">
                {/* ヒーロー */}
                <div className="l-hero">
                  <img
                    className="l-hero__img"
                    src="/Common_Title.jpg"
                    alt="LOUNGE RESERVATION"
                  />
                </div>

                <div className="l-grid">
                  {/* よくあるご質問 - 目次 */}
                  <section className="l-card">
                    <h2 className="l-card__title">{t('faq.title')}</h2>
                    <div className="l-card__body">
                      <div className="faq__link-list">
                        {faqCategories.map((category) => (
                          <div key={category.id} className="faq__link-item">
                            <a
                              className="link-button link-button--faq"
                              href={`#${category.id}-card`}
                            >
                              {category.icon && (
                                <img
                                  src={category.icon}
                                  alt={category.title}
                                  className="link-button--icon"
                                />
                              )}
                              {category.title}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </section>

                  {/* FAQ カテゴリーセクション */}
                  {faqCategories.map((category) => (
                    <section
                      key={category.id}
                      className="l-card"
                      id={`${category.id}-card`}
                    >
                      <h3 className="faq__title">
                        {category.icon && (
                          <img
                            src={category.icon}
                            alt={category.title}
                            className="faq__title--icon"
                          />
                        )}
                        {category.title}
                      </h3>
                      <div className="l-card__body">
                        {category.items.map((item) => {
                          const isOpen = openItems.has(item.id);
                          return (
                            <div
                              key={item.id}
                              className={`faq__item  ${isOpen ? 'is-open' : ''}`}
                            >
                              <div
                                className="faq__question"
                                onClick={() => toggleItem(item.id)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    toggleItem(item.id);
                                  }
                                }}
                              >
                                <div className="faq__label faq__label--q"></div>
                                <div className="faq__question-text">
                                  {item.question}
                                </div>
                                <div className={`faq__question-icon`}></div>
                              </div>
                              {isOpen && (
                                <div className="faq__answer-wrap">
                                  <div className="faq__label faq__label--a"></div>
                                  <div className="faq__answer">
                                    {item.answer}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </section>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};
